import type { TypedUseSelectorHook } from 'react-redux'

import { configureStore } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'

import { appSlice } from './app/app'
import { checkRegisterSlice } from './check-register/check-slice'
import { groupScheduleSlice } from './group-schedule/group-schedule.index'
import { gridSlice } from './payment-files'
import { previewerReducer } from './previewer'
import { metricsSlice } from './processingDashboard/pd.index'

export const store = configureStore({
  reducer: {
    app: appSlice.reducer,
    grid: gridSlice.reducer,
    check: checkRegisterSlice.reducer,
    gridShedule: groupScheduleSlice.reducer,
    metrics: metricsSlice.reducer,
    previewer: previewerReducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
